
import Breadcrumb from '@/components/Breadcrumb/index'
import Sidebar from '@/components/AccountMain/SideBar/SideBar'
import { mapGetters } from 'vuex'
import AccountRouter from '@/components/AccountMain/account-router.js'
export default {
	components: {
		Sidebar,
		Breadcrumb
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			userAccount: 'user/userAccount',
			centerMenu: 'menu/centerMenu'
		}),
		menuList() {
			let menu = this.centerMenu?.length > 0 ? this.centerMenu : [...AccountRouter]

			// 如果是 promotionRebate 页面，隐藏所有菜单项（相当于隐藏整个侧边栏）
			const currentPath = this.$route?.path || ''
			if (currentPath === '/promotionRebate' || currentPath === '/promotionDetail') {
				menu = menu.map(item => ({ ...item, hide: true }))
			}

			return menu
		},
		showSidebar() {
			// 获取当前路由路径
			const currentPath = this.$route?.path || ''
			// 定义需要隐藏侧边栏的页面路径
			const hideSidebarPaths = ['/promotionRebate', '/promotionDetail', '/account/similar']
			// 如果当前路径在隐藏列表中，则不显示侧边栏
			return !hideSidebarPaths.includes(currentPath)
		}
	},
	provide() {
		return {
			reloadAccount: this.reloadAccount
		}
	},
	data() {
		return {
			isRouterAccountAlive: true,
			activeNames: []
		}
	},
	methods: {
		reloadAccount() {
			this.isRouterAccountAlive = false
			this.$nextTick(function () {
				this.isRouterAccountAlive = true
			})
		},
		/**
		 * 设置商家中心子级菜单
		 */
		setBusinessNav() {
			return new Promise(resolve => {
				let menu = [...this.centerMenu]
				let userinfo = this.userinfo
				// 如果不是商家就隐藏商家中心
				if (!userinfo?.recovery) {
					menu.forEach(item => {
						if (item.path == '/account/business') item.hide = true
					})
				}
				resolve(menu)
			})
		}
	},
	async created() {
		if (process.client) {
			await this.$store.dispatch('user/UserCenterStatistics')

			const menu = await this.setBusinessNav()
			await this.$store.dispatch('menu/onSetCenterDotMenu', {
				menu,
				userAccount: this.userAccount
			})
			this.$store.dispatch('user/UserCenterCouponDot')
		}
	}
}
